import { getObjectUtil } from 'packages/src'
import { EXERCISE_LOG_SUMMARIES_PATH } from '../../constants'
import getByIdReduxSelector from '../../../redux/selectors/get-by-id'
import { createSelector } from 'reselect'

function getByExerciseIdExerciseLogSummarySelector (exerciseId) {
  return createSelector(getByIdReduxSelector(
    EXERCISE_LOG_SUMMARIES_PATH.EXERCISE_ID_MAP,
    exerciseId
  ),
  state => getObjectUtil(state, EXERCISE_LOG_SUMMARIES_PATH.DATA),
  (exerciseLogSummaryId, exerciseLogSummariesDomainMap) => {
    return exerciseLogSummariesDomainMap[exerciseLogSummaryId]
  }
  )
}

export default getByExerciseIdExerciseLogSummarySelector
